import { render, staticRenderFns } from "./UserSetPassword.vue?vue&type=template&id=73cc717e&scoped=true"
import script from "./UserSetPassword.vue?vue&type=script&lang=js"
export * from "./UserSetPassword.vue?vue&type=script&lang=js"
import style0 from "./UserSetPassword.vue?vue&type=style&index=0&id=73cc717e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc717e",
  null
  
)

export default component.exports